import axios from 'axios';
const settings = require('./settings.js');

const AXIOS = axios.create({
  baseURL: settings.API_URL
/*   baseURL: 'http://localhost:5000/' */
});

AXIOS.interceptors.request.use(
  config => {
    config.headers['token'] = JSON.parse(window.localStorage.getItem("token"));
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

export default AXIOS;

